import React from 'react';
import { BuildingIcon, MapPinIcon } from 'lucide-react';
interface AllLocationsPlaceholderProps {
  title: string;
  description?: string;
}
export function AllLocationsPlaceholder({
  title,
  description
}: AllLocationsPlaceholderProps) {
  return <div className="bg-gradient-to-br from-slate-50 to-gray-100 rounded-lg border border-dashed border-gray-300 p-8 flex flex-col items-center justify-center text-center min-h-[200px]" data-id="element-79">
      <div className="w-14 h-14 rounded-full bg-slate-200 flex items-center justify-center mb-4" data-id="element-80">
        <BuildingIcon size={24} className="text-slate-500" data-id="element-81" />
      </div>
      <h3 className="text-base font-semibold text-gray-700 mb-2" data-id="element-82">{title}</h3>
      <p className="text-sm text-gray-500 max-w-xs" data-id="element-83">
        {description || 'This feature is available when viewing all locations. Select "All Locations" from the filter to see this data.'}
      </p>
      <div className="mt-4 flex items-center gap-2 px-3 py-1.5 bg-blue-50 border border-blue-200 rounded-full" data-id="element-84">
        <MapPinIcon size={14} className="text-blue-500" data-id="element-85" />
        <span className="text-xs font-medium text-blue-700" data-id="element-86">All Locations</span>
      </div>
    </div>;
}